<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">フィラー</div>
    <div class="text-subtitle2">フィラーのスタイル設定</div>
    <div class="row q-mt-md">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>タイプ<span class="text-brand-red">*</span></div>
        <div class="text-caption">Type</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.type"
        :options="typeList"
        class="col"
        disable
      >
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>フレックス</div>
        <div class="text-caption">Flex</div>
      </div>
      <q-input
        outlined
        dense
        type="number"
        min="0"
        v-model.number="value.flex"
        placeholder="Num."
        class="col"
      />
    </div>
  </q-form>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageFiller } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Filler extends Vue {
  @Prop()
  modelValue!: IFlexMessageFiller

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageFiller) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'フィラー',
        value: 'filler',
      },
    ]
  }
}
</script>

<style scoped lang="scss">

</style>
